/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BusinessCaseListExportRequest,
  BusinessCaseListFilterOptionsResponse,
  BusinessCaseListStatsResponse,
  GetBusinessCaseByNumberResponse,
  ListRequest,
  ListResponseOfBusinessCaseListItem,
  ListResponseOfPartnerSuggestion
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const getBusinessCaseByNumber = (
    number: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetBusinessCaseByNumberResponse>(
      {url: `/api/reservations/business-cases/by-number/${number}`, method: 'GET', signal
    },
      );
    }
  



export const getGetBusinessCaseByNumberQueryKey = (number?: number,) => {
    return [
    `/api/reservations/business-cases/by-number/${number}`
    ] as const;
    }

    
export const getGetBusinessCaseByNumberQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError = ErrorType<unknown>>(number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessCaseByNumberQueryKey(number);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessCaseByNumber>>> = ({ signal }) => getBusinessCaseByNumber(number, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(number), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessCaseByNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessCaseByNumber>>>
export type GetBusinessCaseByNumberQueryError = ErrorType<unknown>


export function useGetBusinessCaseByNumber<TData = Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError = ErrorType<unknown>>(
 number: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessCaseByNumber>>,
          TError,
          Awaited<ReturnType<typeof getBusinessCaseByNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessCaseByNumber<TData = Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError = ErrorType<unknown>>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessCaseByNumber>>,
          TError,
          Awaited<ReturnType<typeof getBusinessCaseByNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessCaseByNumber<TData = Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError = ErrorType<unknown>>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBusinessCaseByNumber<TData = Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError = ErrorType<unknown>>(
 number: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCaseByNumber>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessCaseByNumberQueryOptions(number,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const reservationsBusinessCaseList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfBusinessCaseListItem>(
      {url: `/api/reservations/business-cases/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getReservationsBusinessCaseListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['reservationsBusinessCaseList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsBusinessCaseList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  reservationsBusinessCaseList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsBusinessCaseListMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsBusinessCaseList>>>
    export type ReservationsBusinessCaseListMutationBody = ListRequest
    export type ReservationsBusinessCaseListMutationError = ErrorType<unknown>

    export const useReservationsBusinessCaseList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsBusinessCaseList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getReservationsBusinessCaseListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const reservationsBusinessCaseListExport = (
    businessCaseListExportRequest: BusinessCaseListExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/reservations/business-cases/list/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessCaseListExportRequest, signal
    },
      );
    }
  


export const getReservationsBusinessCaseListExportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListExport>>, TError,{data: BusinessCaseListExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListExport>>, TError,{data: BusinessCaseListExportRequest}, TContext> => {

const mutationKey = ['reservationsBusinessCaseListExport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsBusinessCaseListExport>>, {data: BusinessCaseListExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  reservationsBusinessCaseListExport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsBusinessCaseListExportMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsBusinessCaseListExport>>>
    export type ReservationsBusinessCaseListExportMutationBody = BusinessCaseListExportRequest
    export type ReservationsBusinessCaseListExportMutationError = ErrorType<unknown>

    export const useReservationsBusinessCaseListExport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListExport>>, TError,{data: BusinessCaseListExportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsBusinessCaseListExport>>,
        TError,
        {data: BusinessCaseListExportRequest},
        TContext
      > => {

      const mutationOptions = getReservationsBusinessCaseListExportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const reservationsBusinessCaseListFilterOptions = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BusinessCaseListFilterOptionsResponse>(
      {url: `/api/reservations/business-cases/list/filter-options`, method: 'GET', signal
    },
      );
    }
  



export const getReservationsBusinessCaseListFilterOptionsQueryKey = () => {
    return [
    `/api/reservations/business-cases/list/filter-options`
    ] as const;
    }

    
export const getReservationsBusinessCaseListFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReservationsBusinessCaseListFilterOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>> = ({ signal }) => reservationsBusinessCaseListFilterOptions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReservationsBusinessCaseListFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>>
export type ReservationsBusinessCaseListFilterOptionsQueryError = ErrorType<unknown>


export function useReservationsBusinessCaseListFilterOptions<TData = Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsBusinessCaseListFilterOptions<TData = Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>,
          TError,
          Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReservationsBusinessCaseListFilterOptions<TData = Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useReservationsBusinessCaseListFilterOptions<TData = Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListFilterOptions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReservationsBusinessCaseListFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const reservationsBusinessCaseListStats = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BusinessCaseListStatsResponse>(
      {url: `/api/reservations/business-cases/list/stats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getReservationsBusinessCaseListStatsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListStats>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListStats>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['reservationsBusinessCaseListStats'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reservationsBusinessCaseListStats>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  reservationsBusinessCaseListStats(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReservationsBusinessCaseListStatsMutationResult = NonNullable<Awaited<ReturnType<typeof reservationsBusinessCaseListStats>>>
    export type ReservationsBusinessCaseListStatsMutationBody = ListRequest
    export type ReservationsBusinessCaseListStatsMutationError = ErrorType<unknown>

    export const useReservationsBusinessCaseListStats = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reservationsBusinessCaseListStats>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reservationsBusinessCaseListStats>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getReservationsBusinessCaseListStatsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getReservationsPartnerSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfPartnerSuggestion>(
      {url: `/api/reservations/partners`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetReservationsPartnerSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getReservationsPartnerSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getReservationsPartnerSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getReservationsPartnerSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getReservationsPartnerSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getReservationsPartnerSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetReservationsPartnerSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getReservationsPartnerSuggestions>>>
    export type GetReservationsPartnerSuggestionsMutationBody = ListRequest
    export type GetReservationsPartnerSuggestionsMutationError = ErrorType<unknown>

    export const useGetReservationsPartnerSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getReservationsPartnerSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getReservationsPartnerSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetReservationsPartnerSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    